/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-profile__avatar[_ngcontent-%COMP%]{position:relative}.edit-profile__avatar[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{position:absolute;right:0;float:none}"];
export { styles as styles };
